import {connect} from 'react-redux';

import {makeMapDispatchToProps} from '../../../../srcCommon/helpers/reselectHelpers';
import {updateCardAvatarAsyncAction} from '../../../store/data/cards/cardsActions';
import {ContactHeaderAvatar} from './contactHeaderAvatar';

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  updateCardAvatarAsync: updateCardAvatarAsyncAction,
}));

export const ContactHeaderAvatarContainer = connect(null, mapDispatchToProps)(ContactHeaderAvatar);
